
(function () {
  'use strict';


  const TRANSIT = { DE: [3, 5], AT: [5, 6], BE: [5, 6], NL: [4, 5], IT: [6, 8] };
  const DAY = 86400000;
  const calendar = (year, month, day) => new Date(Date.UTC(year, month - 1, day, 12));
  const iso = date => date.toISOString().slice(0, 10);
  const shift = (date, days) => new Date(date.getTime() + days * DAY);
  function berlinToday(now = new Date()) {
    const parts = new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/Berlin', year: 'numeric', month: 'numeric', day: 'numeric' }).formatToParts(now);
    const get = type => Number(parts.find(part => part.type === type).value);
    return calendar(get('year'), get('month'), get('day'));
  }
  function easter(year) {
    const a = year % 19, b = Math.floor(year / 100), c = year % 100;
    const d = Math.floor(b / 4), e = b % 4, f = Math.floor((b + 8) / 25);
    const g = Math.floor((b - f + 1) / 3), h = (19 * a + b - d - g + 15) % 30;
    const i = Math.floor(c / 4), k = c % 4, l = (32 + 2 * e + 2 * i - h - k) % 7;
    const m = Math.floor((a + 11 * h + 22 * l) / 451), n = h + l - 7 * m + 114;
    return calendar(year, Math.floor(n / 31), n % 31 + 1);
  }
  const holidayCache = new Map();
  function holidays(year, country) {
    const key = year + country;
    if (holidayCache.has(key)) return holidayCache.get(key);


    const fixed = {
      DE: ['01-01', '05-01', '10-03', '12-25', '12-26'],
      AT: ['01-01', '01-06', '05-01', '08-15', '10-26', '11-01', '12-08', '12-25', '12-26'],
      BE: ['01-01', '05-01', '07-21', '08-15', '11-01', '11-11', '12-25'],
      NL: ['01-01', '05-05', '12-25', '12-26'],
      IT: ['01-01', '01-06', '04-25', '05-01', '06-02', '08-15', '11-01', '12-08', '12-25', '12-26']
    };
    const offsets = { DE: [-2, 1, 39, 50], AT: [1, 39, 50, 60], BE: [1, 39, 50], NL: [-2, 1, 39, 50], IT: [1] };
    const dates = new Set((fixed[country] || []).map(day => year + '-' + day));
    for (const offset of offsets[country] || []) dates.add(iso(shift(easter(year), offset)));
    if (country === 'NL') {
      const kingsDay = calendar(year, 4, 27);
      dates.add(iso(kingsDay.getUTCDay() === 0 ? shift(kingsDay, -1) : kingsDay));
    }
    holidayCache.set(key, dates);
    return dates;
  }
  function addWorkingDays(start, count, { country = 'DE', saturday = false, closures = [] } = {}) {
    let date = new Date(start.getTime()), remaining = count;
    const closed = new Set(closures);
    while (remaining > 0) {
      date = shift(date, 1);
      const day = date.getUTCDay();
      if (day !== 0 && (saturday || day !== 6) && !holidays(date.getUTCFullYear(), country).has(iso(date)) && !closed.has(iso(date))) remaining--;
    }
    return date;
  }
  function estimate(today, country, { prepMin = 1, prepMax = 1, closures = [] } = {}) {
    if (!(today instanceof Date) || !Number.isFinite(today.getTime())) throw new TypeError('Invalid calendar date');
    const transit = TRANSIT[country];
    if (!transit) return null;
    if (![prepMin, prepMax].every(value => Number.isInteger(value) && value >= 0 && value <= 30) || prepMax < prepMin) throw new RangeError('Invalid preparation interval');
    const earliestDispatch = addWorkingDays(today, prepMin, { closures });
    const latestDispatch = addWorkingDays(today, prepMax, { closures });
    return {
      start: addWorkingDays(earliestDispatch, transit[0], { country, saturday: true }),
      end: addWorkingDays(latestDispatch, transit[1], { country, saturday: true })
    };
  }
  function formatRange(start, end, locale = 'de-DE') {
    const format = new Intl.DateTimeFormat(locale, { day: 'numeric', month: 'long', timeZone: 'UTC' });
    if (start.getUTCFullYear() !== end.getUTCFullYear()) {
      const full = new Intl.DateTimeFormat(locale, { day: 'numeric', month: 'long', year: 'numeric', timeZone: 'UTC' });
      return full.format(start) + ' – ' + full.format(end);
    }
    if (locale.startsWith('de') && start.getUTCMonth() === end.getUTCMonth()) return start.getUTCDate() + '.–' + format.format(end);
    return format.format(start) + ' – ' + format.format(end);
  }
  function formatBetween(start, end, locale = 'de-DE', pattern = 'Lieferung zwischen __START__ und __END__') {
    const differentYear = start.getUTCFullYear() !== end.getUTCFullYear();
    const format = new Intl.DateTimeFormat(locale, {
      day: 'numeric', month: 'long', ...(differentYear ? { year: 'numeric' } : {}), timeZone: 'UTC'
    });
    const sameMonth = !differentYear && start.getUTCMonth() === end.getUTCMonth();
    const first = locale.startsWith('de') && sameMonth ? start.getUTCDate() + '.' : format.format(start);
    return pattern.replace('__START__', first).replace('__END__', format.format(end));
  }
  function suggestedCountry(response) {
    const handle = response?.detected_values?.country?.handle || response?.suggestions?.[0]?.parts?.country?.handle;
    return typeof handle === 'string' && /^[A-Z]{2}$/.test(handle) ? handle : null;
  }
  function resolveCountry(active, detected) {
    const current = typeof active === 'string' && /^[A-Z]{2}$/.test(active) ? active : 'DE';
    // Respect an active international market instead of replacing a shopper's selection.
    return current === 'DE' && typeof detected === 'string' && /^[A-Z]{2}$/.test(detected) ? detected : current;
  }
  if (typeof module === 'object' && module.exports) module.exports = {
    TRANSIT, calendar, iso, berlinToday, holidays, addWorkingDays, estimate, formatRange,
    formatBetween, suggestedCountry, resolveCountry
  };
  if (typeof window === 'undefined' || !window.customElements || customElements.get('mc-delivery-estimate')) return;

  let countrySuggestion;
  function getCountrySuggestion() {
    if (!countrySuggestion) {
      countrySuggestion = (async () => {
        const controller = new AbortController();
        const timer = setTimeout(() => controller.abort(), 2500);
        try {
          const root = window.Shopify?.routes?.root || '/';
          const response = await fetch(root + 'browsing_context_suggestions.json?country[enabled]=true&country[exclude]=DE', {
            signal: controller.signal, credentials: 'same-origin'
          });
          return response.ok ? suggestedCountry(await response.json()) : null;
        } catch {
          return null;
        } finally {
          clearTimeout(timer);
        }
      })();
    }
    return countrySuggestion;
  }

  class DeliveryEstimate extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      clearInterval(this.timer);
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.country = resolveCountry(this.dataset.country);
      document.addEventListener('visibilitychange', () => { if (!document.hidden) this.update(); }, { signal });
      this.timer = setInterval(() => { if (!document.hidden && iso(berlinToday()) !== this.today) this.update(); }, 60000);
      this.update();
      if (this.country === 'DE') {
        getCountrySuggestion().then(country => {
          if (signal.aborted || !this.isConnected) return;
          this.country = resolveCountry(this.dataset.country, country);
          this.update();
        });
      }
    }
    disconnectedCallback() { this.controller?.abort(); clearInterval(this.timer); }
    update() {
      const dates = this.querySelector('[data-delivery-range]');
      if (!dates) return;
      const today = berlinToday(), country = this.country;
      this.today = iso(today);
      const range = estimate(today, country, {
        prepMin: Number(this.dataset.prepMin || 1), prepMax: Number(this.dataset.prepMax || 1),
        closures: (this.dataset.closures || '').split(',').map(value => value.trim()).filter(Boolean)
      });
      dates.textContent = range
        ? formatBetween(range.start, range.end, this.dataset.locale || 'de-DE', this.dataset.between)
        : this.dataset.unknown;
      this.dataset.destination = country;
      this.dataset.estimated = String(Boolean(range));
      this.dataset.start = range ? iso(range.start) : '';
      this.dataset.end = range ? iso(range.end) : '';
    }
  }
  customElements.define('mc-delivery-estimate', DeliveryEstimate);
})();
